import { extend } from 'underscore';

export const getFooterButtonStyles = ({
  styleOverrides = {},
}) => (_, { palette = {} }) => ({
  footerButton: extend({
    position: 'relative',
    float: 'right',
    bottom: 113,
    color: palette.themePrimary,
    '& .iconba': {
      top: 1,
      fontSize: 16,
    },
  }, styleOverrides.footerButton),
});
